export default __webpack_public_path__ + "static/media/location.96a95487.png";